import React from "react";
import * as styles from "./InspectionResultBox.module.scss";
import classNames from "classnames";
import Info from "@app/components/Info";
import List from "@app/components/List";
import { DEPLOYMENT_STATE_HINTS, DEPLOYMENT_STATE_KEYS, mapDeploymentErrorCount } from "@app/utils/confirmationState";
import Badge from "@app/components/Badge";
// import Select from "@app/components/Select";
// import FieldHelper from "@app/components/FormikHelper";
import { useField /*useFormikContext*/ } from "formik";
import Hint from "@app/components/Hint/Hint";
import { useRouteLoaderData, useNavigate } from "react-router-dom";
import Config from "@app/constants/Config";
//import PropTypes from 'prop-types'

export const resultContentMap = {
	possible: {
		label: "Ein Einsatz ist möglich", // Ein Einsatz ist mit den beschriebenen Maßnahmen möglich
		icon: "check-circle",
		copy: "Obwohl folgende Ursachen wurden festgestellt wurden:",
	},
	possible_with_measures: {
		label: "Ein Einsatz ist nach Umsetzung der Maßnahmen möglich", // Einsatz nach Umsetzung Maßnahmen durch Kunde und/oder Tempton möglich
		icon: "warning-lines",
		copy: "Folgende Ursachen wurden festgestellt:",
	},
	not_possible: {
		label: "Ein Einsatz ist nicht möglich",
		icon: "x-circle",
		copy: "Folgende Ursachen wurden festgestellt:",
	},
};

const labelResultMap = Object.entries(resultContentMap).reduce(
	(acc, [key, value]) => ({ ...acc, [value.label]: key }),
	{},
);

const InspectionResultBox = ({ name, label, deploymentState, steps }) => {
	const { inspection } = useRouteLoaderData("inspection");
	const [{ value }] = useField({ name });
	const [{ value: suitableForMothersValue }] = useField({
		name: "festsetzung_geeignet-fuer-werdende-stillende-muetter",
	});

	const resultKey = labelResultMap[value];
	const content = resultContentMap[resultKey];
	const navigate = useNavigate();

	const validationItems = steps
		.map(({ header }, index) => ({ copy: `${index + 1}. ${header}` }))
		.map((step, index) => {
			const deploymentErrorCount = mapDeploymentErrorCount(deploymentState[index]);
			return {
				...step,
				badges: DEPLOYMENT_STATE_KEYS.map((key) =>
					deploymentErrorCount[key] > 0 ? (
						<Badge
							key={key}
							className={styles.badge}
							state={key}
							dot={false}
							bg="secondary"
							label={deploymentErrorCount[key]}
							hint={DEPLOYMENT_STATE_HINTS[key]}
						/>
					) : null,
				),
			};
		})
		.filter(({ badges }) => {
			return badges[0] !== null || badges[1] !== null || badges[2] !== null;
		})
		.map((step) => (
			<>
				<div>{step.copy}</div>
				<div>{step.badges}</div>
			</>
		));

	const consolidatedState = deploymentState.reduce(
		(res, entry) => ({
			not_possible: {
				...res.not_possible,
				...entry.not_possible,
			},
			not_suitable_for_mothers: {
				...res.not_suitable_for_mothers,
				...entry.not_suitable_for_mothers,
			},
			possible_with_measures: {
				...res.possible_with_measures,
				...entry.possible_with_measures,
			},
		}),
		{
			not_possible: {},
			not_suitable_for_mothers: {},
			possible_with_measures: {},
		},
	);
	const hasMothersMeasuresHint = Object.keys(consolidatedState.possible_with_measures).find((e) =>
		e.match(
			/physischegefaehrdungsanalyse_gefaehrdungen_gefaehrdungen\[\d+\].physischegefaehrdungsanalyse_zusaetzlichemassnahmen_arbeitsplatzgeeignetfuerwerdendestillendemuetter/,
		),
	);

	const suitableForMothersErrorCount =
		deploymentState.reduce((acc, entry) => [...acc, ...Object.values(entry.not_suitable_for_mothers)], [])
			?.length || 0;
	const isSuitableForMothers = validationItems.length === 0 && suitableForMothersErrorCount === 0;
	const isSuitableWithMeasuresForMothers =
		validationItems.length === 1 && hasMothersMeasuresHint && suitableForMothersErrorCount === 0;

	return (
		<>
			<Info
				icon={content.icon}
				headline={content.label}
				inspectionState={resultKey}
				isError={resultKey === "not_possible"}
				isWarning={resultKey === "possible_with_measures"}
				className={classNames("styles.info", "mb-24")}
				copy={
					validationItems.length > 0 || !isSuitableForMothers ? (
						<>
							{validationItems.length > 0 && (
								<div
									className={styles["list-container"]}
									onClick={() =>
										navigate(`${Config.BASE_PATH}/inspection/${inspection.uuid}/summary`)
									}
								>
									{content.copy && <p>{content.copy}</p>}
									<List
										isIndexed={false}
										noBackground={true}
										condensed
										className={classNames(styles.list)}
										items={validationItems}
									/>
								</div>
							)}

							{!isSuitableForMothers && !isSuitableWithMeasuresForMothers && (
								<Hint
									className={"mt-24 mb-12"}
									label={
										"Hinweis: Der Arbeitsplatz ist nicht für werdende/stillende Mütter geeignet."
									}
								/>
							)}

							{isSuitableWithMeasuresForMothers && (
								<Hint
									className={"mt-24 mb-12"}
									label={
										"Hinweis: Der Arbeitsplatz ist für werdende/stillende Mütter nach Umsetzung der Maßnahmen geeignet."
									}
								/>
							)}
							{
								// Die Auswahlmöglichkeit zur Änderung des Status wurde auf Kundenwunsch ausgeblendet
								/*
						<FieldHelper
							className={classNames(styles.select, "mt-18")}
							key={name}
							name={name}
							component={Select}
							isMulti={false}
							options={Object.values(resultContentMap).map(({ label }) => ({
								value: label,
								label,
							}))}
							label={label}
							disabled={false}
							required={false}
							placeholder={"Bitte wählen"}
							instantRequired={false}
							selectAllOption={false}
						/>
						*/
							}
						</>
					) : null
				}
			/>
		</>
	);
};

InspectionResultBox.propTypes = {};

export default InspectionResultBox;
